import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDataOverview = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 21c-.55 0-1.02-.195-1.411-.587A1.931 1.931 0 0 1 3 19V5c0-.55.195-1.02.589-1.412A1.933 1.933 0 0 1 4.999 3H19c.55 0 1.02.195 1.413.588.393.391.587.863.587 1.412v14c0 .55-.194 1.021-.586 1.413a1.926 1.926 0 0 1-1.413.587H5Zm0-2h6V5H5v14Zm8 0h6.001v-7h-6v7Zm0-9h6.001V5h-6v5Z",
		fill: "currentColor"
	})
});
export default SvgDataOverview;
